<template>
  <div
    class="custom-select"
    :class="`custom-select--${type}`"
    v-click-outside="outsideClick">
    <div
      @click.prevent="toggle"
      class="custom-select__input"
      :class="{ 'custom-select__input--open': showDropdown }">
      <div class="custom-select__label">
        <template v-if="!objectEmpty(selectedOption)">
          <p>{{ selectedOption?.label }}</p>
          <div v-if="selectedOption?.description"
            class="custom-select__label-description">
            <span>{{ selectedOption?.description }}</span>
          </div>
        </template>
        <p v-else>{{ t.select }}</p>
      </div>
    </div>
    <transition name="custom-select-dropdown">
      <div v-show="showDropdown" class="custom-select__dropdown">
        <!-- Options list. -->
        <ul class="custom-select__items">
          <li
            v-for="(option, i) in options"
            :key="`${option.id}-${option.label}-${i}`"
            class="custom-select__item">
            <input
              :id="`custom-select-${i}`"
              class="custom-select__radio visually-hidden"
              type="radio"
              :value="option.id" />
            <label
              :for="`custom-select-${i}`"
              class="custom-select__list-label"
              :class="{
                'custom-select__list-label--selected':
                  option.id === selectedOption.id,
              }"
              @click.prevent="select(option.id)">
              <p>{{ option.label }}</p>
              <div v-if="option.description"
                class="custom-select__label-description">
                <span>{{ option.description }}</span>
              </div>
            </label>
          </li>
          <li
            v-if="options.length === 0"
            class="custom-select__item custom-select__item--empty">
            <label class="custom-select__list-label">
              <span>{{ t.noResults }}</span>
            </label>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
// Directives.
import clickOutside from '../directives/clickOutside';
// Utils.
import translationStrings from '../utils/translation-strings';

export default {
  name: 'custom-select',
  directives: {
    clickOutside,
  },
  props: {
    value: {}, // v-model
    options: {
      required: true,
      type: Array,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedOption: {},
      showDropdown: false,
      t: translationStrings,
    };
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.getSelectedOption();
      }
    },
  },
  mounted() {
    this.getSelectedOption();
  },
  methods: {
    getSelectedOption() {
      this.selectedOption = this.options.find((o) => o.id === this.value) || {};
    },
    select(id) {
      this.$emit('input', id);
      this.outsideClick();
    },
    toggle() {
      this.showDropdown = !this.showDropdown;
    },
    outsideClick() {
      this.showDropdown = false;
    },
    objectEmpty(obj) {
      // @todo make this reusable already
      return obj !== null && Object.keys(obj).length === 0;
    },
  },
};
</script>
